import { render, staticRenderFns } from "./PlpDataForm.vue?vue&type=template&id=973fa310&scoped=true"
import script from "./PlpDataForm.vue?vue&type=script&lang=js"
export * from "./PlpDataForm.vue?vue&type=script&lang=js"
import style0 from "./PlpDataForm.vue?vue&type=style&index=0&id=973fa310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973fa310",
  null
  
)

export default component.exports